import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, Observable, Subscription, timer } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TIEMPO_INACTIVO } from '../../routes.constans';
import { ExceptionRequest } from '../../Models/exceptionRequest';
import { ExceptionService } from '../excepciones/exception.service';
import { DatosGenerales } from '../../Models/datosGenerales';
import { Store } from '@ngrx/store';
import { selectData } from '../../storage/Lead/data.selectors';
import { Location } from '@angular/common';
import { getSessionId } from '../../helpers/storageUtils';

@Injectable({
  providedIn: 'root'
})

export class TiempoInactivoService {
  private inactivitySubscription: Subscription | undefined;
  localTimer = environment.LOCAL_TIMER;
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;
  sessionId: string = '';
  codAsesor: string = '';

  envio: ExceptionRequest = {
    percentege_lead: '',
    required_status: ''
  }

  constructor(
    private router: Router,
    private exceptionService: ExceptionService,
    private store: Store,
    private location: Location
  ) {
    this.datosGenerales$ = this.store.select(selectData);
  }


  startMonitoring(porcentageLead: string, status: string, url?:string): void {
    this.sessionId = getSessionId().toString();

    // Obtener la URL actual

    console.log('URL: ACTUAL: ', url);

    this.datosGenerales$.subscribe((data) => { this.datosGenerales = data; });

    const mouseMove$ = fromEvent(document, 'mousemove');
    const keyPress$ = fromEvent(document, 'keydown');

    this.inactivitySubscription = mouseMove$
      .pipe(
        debounceTime(200), // Para evitar eventos muy frecuentes.
        switchMap(() => timer(this.localTimer)) // Reinicia el temporizador en cada evento.
      )
      .subscribe(() => {
        this.crearLead(porcentageLead, status);
        this.handleInactivity();
      });
  }

  crearLead(porcentageLead: string, status: string) {
    this.envio.percentege_lead = porcentageLead;
    this.envio.required_status = status;

    if (this.envio) {
      this.exceptionService.addException(this.sessionId, this.datosGenerales?.LeadResponse.data.Id || '', this.envio)
        .subscribe(
          (data) => {
            const response = data;
          }
        );
    } else {
      // Handle the case where datosLead is undefined
      console.error('datosLead is undefined');
    }
  }

  handleInactivity() {
    if (this.codAsesor === undefined || this.codAsesor === '') {
      this.router.navigate([TIEMPO_INACTIVO]);
    } else {
      this.router.navigate([TIEMPO_INACTIVO], { queryParams: { codigoAsesor: this.codAsesor } });
    }
  }

  stopMonitoring(): void {
    this.inactivitySubscription?.unsubscribe();
  }

  ngOnDestroy(): void {
    this.stopMonitoring();
  }
}
